import { useEffect } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'

import { useDataProviderContext } from '../contexts/DataProviderContext'
import { useResourceRecordContext } from '../contexts/ResourceRecordContextObject'

export const ResourceRecordForm = ({
  validationSchema,
  onSubmit,
  onSave,
  defaultValues: propDefaultValues,
  children,
  ...rest
}) => {
  const {
    record,
    apiBasePath,
    id,
    setIsSubmitting,
    setSavedRecord,
  } = useResourceRecordContext() || {}
  const { dataProvider, httpClient } = useDataProviderContext() || {}

  const methods = useForm({
    defaultValues: record ?? propDefaultValues ?? {},
    shouldUnregister: false,
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
  })

  useEffect(() => {
    if (record) methods.reset(record)
  }, [record])

  const handleFormSubmit = async data => {
    if (onSubmit) {
      await onSubmit(data)
      onSave && onSave()
      return
    }

    setIsSubmitting?.(true)
    try {
      const res = id
        ? await dataProvider.update(apiBasePath, id, { record: data })
        : await httpClient.put(apiBasePath, { record: data })
      const saved = res?.data ?? data
      setSavedRecord?.(saved)
      onSave && onSave(saved)
    } catch {
      // errors handled by API interceptor
    } finally {
      setIsSubmitting?.(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleFormSubmit)} {...rest}>
        {children}
      </form>
    </FormProvider>
  )
}
